import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Homepage } from "./Homepage";
import UserLogin from "./Login";
import { MainPage } from "./Main Page/MainPage";
import { Marketing } from "./Marketing";
import { SitesStore } from "./Sites and Store/SitesStore";
import { Company } from "./Company/Company";
import AdminPanel from "./Admin/AdminPanel";
import Profile from "./Profile/Profile";
import UserProfile from "./Profile/UserProfile";
import AcceptInvite from "./Invite/AcceptInvite";
import ProjectsList from "./Projects/ProjectsList";
import ProjectDetail from "./Projects/ProjectDetail";
import DepartmentWorkspace from "./Projects/DepartmentWorkspace";
import TasksPage from "./Tasks/TasksPage";
import Dashboard from "./Dashboard/Dashboard";
import ChatPage from "./Chat/ChatPage";
import AnalyticsPage from "./Analytics/AnalyticsPage";
import TaskTimeline from "./Analytics/TaskTimeline";
// HR plugin routes live in HRApp.jsx — served only by the standalone HR build
// (REACT_APP_MODE=hr). They are intentionally NOT imported here so the Bitrix
// task-management build does not include HR pages. Future plug-in: import
// the relevant pages and add their <Route> entries below.
import AppShell from "../Components/AppShell";

const RequireAuth = ({ children }) => {
  if (!localStorage.getItem("token")) return <Navigate to="/login" replace />;
  return children;
};

const RootRedirect = () => {
  if (localStorage.getItem("token")) return <Navigate to="/dashboard" replace />;
  return <Homepage />;
};

export const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<UserLogin />} />
      <Route path="/invite/:token" element={<AcceptInvite />} />
      <Route path="/marketing" element={<Marketing />} />
      <Route path="/sites" element={<SitesStore />} />
      <Route path="/company" element={<Company />} />

      <Route element={<RequireAuth><AppShell /></RequireAuth>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/users/:id" element={<UserProfile />} />
        <Route path="/projects" element={<ProjectsList />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/projects/:id/dept/:deptId" element={<DepartmentWorkspace />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/analytics/timeline/task/:taskId" element={<TaskTimeline />} />
        {/* HR routes (/hr, /attendance, /leaves, /notices, /holidays, /performance)
            live on the standalone HR deploy (REACT_APP_MODE=hr → HRApp.jsx). */}
      </Route>

      <Route path="/stream" element={<RequireAuth><MainPage /></RequireAuth>} />
    </Routes>
  );
};
